import { LogLevel } from '@microsoft/signalr';

// UAT environment — single-box UAT cluster (vnj-*.uat.leap.vn), as-built 2026-07-07.
// secretKey / apiSecretKey are REUSED FROM PROD because UAT runs the prod-built backend
// images (baked prod TokenSecretKey / AES key) — they must match for request crypto + auth.
// ⚠️ In prod, BOTH apiUrl and notificationApiUrl are the Balance API (api-bal:8900), which
// has NO SOURCE (SRC-1) and is not deployed in UAT. Pointed at VNJMobileAPI (vnj-api-m) — the
// source-available backend that implements the endpoints the portal needs: GET /get-self-info
// and the /notify SignalR hub (BroadcastHubMobileApp), with CORS allowing the portal origin.
// Balance-only endpoints (if any) will still 404 until the Balance API is recovered/stubbed.
export const environment = {
  version: '1.0.2-uat',
  debug: true,
  signalRLogLevel: LogLevel.Information,
  encrypt: true,
  secretKey: 'fUG5rzV8XxEybLwvB7HFsS',

  apiUrl: 'https://vnj-api-m.uat.leap.vn',
  apiSecretKey: 'the-super-secret-vnjsystem-key-for-jwt-token-generation-2024-very-long',
  notificationApiUrl: 'https://vnj-api-m.uat.leap.vn',
  cdnUrl: 'https://cdn.vinajet.vn',

  defaultAgentCode: 'VINAJET_F2',
  defaultEmail: 'qa@vinajet.vn',
  defaultSessionMinutes: [12, 15],
  defaultRetryConnectSignalMinutes: 60,
};
